/*
    Los atributos de marca (MARCA1..MARCA7) no deben mostrarse en la tabla de atributos del
    producto, aunque sí deben poder encontrarse por búsqueda libre.
*/
export const esAtributoMarca = (codAtr) => (codAtr || "").includes("MARCA");

//Códigos de atributo usados para los filtros de Tipo/Grupo/Subgrupo del catálogo de Productos.
export const CODATR_TIPO = "05TIPO";
export const CODATR_GRUPO = "10GRP";
export const CODATR_SUBGRUPO = "15SUBG";

/*
    Arma las opciones (valAtr + descrpVal) de un filtro a partir del listado completo de atributos,
    para un codAtr puntual. Se excluyen los dados de baja y se deduplica por valAtr.
*/
export const getOpcionesAtributo = (atributos = [], codAtr) => {
    const vistos = new Map();
    (atributos || []).forEach((a) => {
        if (a.codAtr !== codAtr || a.debaja === "S") return;
        if (!vistos.has(a.valAtr)) {
            vistos.set(a.valAtr, { valAtr: a.valAtr, descrpVal: a.descrpVal });
        }
    });
    return Array.from(vistos.values()).sort((a, b) =>
        (a.descrpVal || "").localeCompare(b.descrpVal || "")
    );
};

//Un producto cumple un filtro de atributo si tiene un atributo activo con ese codAtr y valAtr (o si el filtro está vacío).
export const cumpleFiltroAtributo = (atributos, codAtr, valAtr) => {
    if (!valAtr) return true;
    return (atributos || []).some(
        (a) => a.codAtr === codAtr && a.valAtr === valAtr && a.debaja !== "S"
    );
};
